
var Scene = require('scene').Scene;

(/** @lends <global> */function (global) {
    'use strict';

    var FiveCardRisk = function(config) {
        Scene.call(this);

        var self = this;

        this.CARDS_NUMBER = config.CARDS_NUMBER || 0;
        this.X_START = config.X_START_CARDS || 0;
        this.Y_CARDS = config.Y_CARDS || 0;
        this.X_START_OFFSET = config.X_START_OFFSET || 0;
        this.X_OFFSET = config.X_OFFSET || 0;

        this.FLIP_TIME = config.FLIP_TIME || 250;

        this.riskStep = 1;

        //Create the sprite from the texture
        var texture = config.background.image || "res/doublegame_background.jpg";
        this.background = new PIXI.Sprite(PIXI.utils.TextureCache[texture]);
        if (config.background.position) {
            this.background.position = config.background.position;
        }
        this.addChild(this.background);

        this.background.interactive = true;
        this.background.buttonMode = true;
        this.background.cursor = 'inherit';

        this.deck = this.createDesk();

        this.shirts = [];
        for (var i = 0; i < this.CARDS_NUMBER; ++i) {
            (function (k) {
                var shirt = new PIXI.Sprite(PIXI.utils.TextureCache[config.shirt || ""]);
                shirt.anchor.x = 0.5;
                shirt.position.set(self.X_START + i * self.X_OFFSET + ((i > 0) ? self.X_START_OFFSET : 0), self.Y_CARDS);
                self.addChild(shirt);
                self.shirts.push(shirt);

                if (k > 0) {
                    shirt.interactive = true;
                    shirt.pointerdown = function(){
                        console.log("SELECTED CARD " + k);
                        // self.onCardSelect(k);
                        self.controller.cardSelected(k, self.riskStep);
                    };
                }
            })(i);
        }

        this.pickShield = new PIXI.Sprite(PIXI.utils.TextureCache[config.pick.image || ""]);
        this.pickShield.position.set(this.X_START + this.X_OFFSET + this.X_START_OFFSET, config.pick.y_position || 0);
        this.pickShield.anchor.x = 0.5;
        this.pickShield.visible = false;
        this.addChild(this.pickShield);

        if (typeof config.dealer == 'object')
            {
                this.dealerShield = new PIXI.Sprite(PIXI.utils.TextureCache[config.dealer.image || ""]);
                this.dealerShield.position.set(this.X_START, config.pick.y_position || 0);
                this.dealerShield.anchor.x = 0.5;
                this.addChild(this.dealerShield);
            }

        this.currentWinLabel = new PIXI.extras.BitmapText("0", {font: config.currentWinLabel.font, align:config.currentWinLabel.align});
        this.addChild(this.currentWinLabel);
        this.currentWinLabel.position.set(config.currentWinLabel.position.x, config.currentWinLabel.position.y);

        switch (config.currentWinLabel.align) {
            case 'left':
                this.currentWinLabel.anchor.set(0.0, 0.0);
                break;

            case 'right':
                this.currentWinLabel.anchor.set(1.0, 0.0);
                break;

            case 'center':
                this.currentWinLabel.anchor.set(0.5, 0.0);
                break;

            default:
                this.currentWinLabel.anchor.set(0.5, 0.0);
                break;
        }

        this.possibleWinLabel = new PIXI.extras.BitmapText("0", {font: config.nextWinLabel.font, align:config.nextWinLabel.align});
        this.addChild(this.possibleWinLabel);
        this.possibleWinLabel.position.set(config.nextWinLabel.position.x, config.nextWinLabel.position.y);

        switch (config.nextWinLabel.align) {
            case 'left':
                this.possibleWinLabel.anchor.set(0.0, 0.0);
                break;

            case 'right':
                this.possibleWinLabel.anchor.set(1.0, 0.0);
                break;

            case 'center':
                this.possibleWinLabel.anchor.set(0.5, 0.0);
                break;

            default:
                this.possibleWinLabel.anchor.set(0.5, 0.0);
                break;
        }

    };


    FiveCardRisk.prototype = Object.create(Scene.prototype);

    FiveCardRisk.prototype.constructor = FiveCardRisk;

    FiveCardRisk.prototype.terminate = function () {

        console.log('FiveCardRisk.prototype.terminate()');

        this.shirts.forEach(function (shirt) {
            shirt.pointerdown = null;
        });

        this.removeChildren();
        this.destroy();

        this.background = null;
        this.deck = null;
        this.shirts = null;
        this.currentWinLabel = null;
        this.possibleWinLabel = null;
        this.pickShield = null;
    };

    FiveCardRisk.prototype.resume = function( state ) {
        // обязательный вызов базовой реализации метода
        Scene.prototype.resume();
    };

    FiveCardRisk.prototype.setRiskStep = function (step) {
        this.riskStep = step;
    };

    FiveCardRisk.prototype.createDesk = function () {
        var deck = [];
        for (var suit = 0; suit < 4; ++suit) {
            for (var nominal = 0; nominal < 13; ++ nominal) {
                var card = this.createCard(suit, nominal);
                card.anchor.x = 0.5;
                deck[suit * 13 + nominal] = card;
                card.visible = false;
                this.addChild(card);
                deck.push(card);
            }
        }
        return deck;
    };

    FiveCardRisk.prototype.startRound = function( data, $startComplete ) {
        console.log("START RISK WITH DATA: " + JSON.stringify(data));

        for (var i = 0; i < this.deck.length; ++i) {
            this.deck[i].visible = false;
        }

        this.setRiskStep(data.step);//this.riskStep = data.step;

        this.currentWinLabel.text = data.currentWin;
        this.possibleWinLabel.text = data.futureWin;

        this.pickShield.visible = false;

        this.shirts[0].scale.x = 1;
        this.shirts[0].visible = true;

        var dealerCardId = data.dealer.suit * 13 + data.dealer.rank;

        console.log('OPENING CARD:', dealerCardId);

        var dealerCard = this.deck[dealerCardId];
        dealerCard.position.set(this.X_START, this.Y_CARDS);
        dealerCard.scale.x = 0.005;
        dealerCard.visible = false;

        this.openCard(0, dealerCardId, function () {
            $startComplete.next();
        });

        for (var i = 1; i < this.CARDS_NUMBER; ++i) {
            this.shirts[i].scale.x = 1.0;
            this.shirts[i].visible = true;
            this.shirts[i].interactive = true;
        }
        this.enableInteraction();
    };

    FiveCardRisk.prototype.disableInteraction = function () {
        for (var i = 1; i < this.CARDS_NUMBER; ++i) {
            this.shirts[i].interactive = false;
        }
    };

    FiveCardRisk.prototype.enableInteraction = function () {
        for (var i = 1; i < this.CARDS_NUMBER; ++i) {
            this.shirts[i].interactive = true;
        }
    };

    FiveCardRisk.prototype.onCardSelect = function (card) {
        this.pickShield.position.x = this.X_START + card * this.X_OFFSET + this.X_START_OFFSET;
        this.pickShield.visible = true;
    };

    FiveCardRisk.prototype.onPlayerWin = function (currentWin, futureWin) {
        this.currentWinLabel.text = currentWin.toString();
        this.possibleWinLabel.text = futureWin.toString();
    };

    FiveCardRisk.prototype.onPlayerLose = function () {
        this.currentWinLabel.text = "0";
        this.possibleWinLabel.text = "0";

    };

    FiveCardRisk.prototype.onForwardEvent = function () {

    };

    FiveCardRisk.prototype.gotoNextRiskStep = function () {

    };

    FiveCardRisk.prototype.startShowResult = function () {

    };

    FiveCardRisk.prototype.showRiskResult = function(data, done) {
        console.log('showRiskResult DATA:', JSON.stringify(data));
        
        //попытка поправить восстановление на состоянии показа раунда которое изначально не дизайнилось: карта дилера должна быть уже показана независимо от того что было прежде:
        var dealerCard = this.deck[ data.processed.dealer.suit * 13 + data.processed.dealer.rank ];
        dealerCard.position.set(this.X_START, this.Y_CARDS);
        dealerCard.scale.x = 1.0;
        dealerCard.visible = true;
        this.shirts[ 0 ].visible = false;

        this.pickShield.position.x = this.X_START + data.processed.choice * this.X_OFFSET + this.X_START_OFFSET;
        this.pickShield.visible = true;

        this.setRiskStep((data.step && data.step > 1) ? (data.step - 1) : 1 );

        if (data.processed.forward) {
            this.showDrawEvent(data, done);
        }
        else {
            // show win result
            if (data.currentWin > 0) {
                this.showPlayerWin(data, done);
            }
            // show lose result
            else {
                this.showPlayerLose(data, done)
            }
        }
    };

    FiveCardRisk.prototype.showPlayerWin = function (data, done) {

        var self = this;

        var cardId = data.processed.cards[data.processed.choice - 1].suit * 13 + data.processed.cards[data.processed.choice - 1].rank;

        this.startShowResult();

        this.openCard(data.processed.choice, cardId, function () {
            setTimeout(function () {

                // OPEN OTHER CARDS

                var cardCounter = 0;

                for (var i = 0; i < this.CARDS_NUMBER - 1; ++i) {
                    (function (k) {
                        if (k + 1 != data.processed.choice) {
                            cardCounter++;
                            cardId = data.processed.cards[k].suit * 13 + data.processed.cards[k].rank;

                            // к последней карте привязываем событие показа баннера и счетчиков
                            self.openCard(k + 1, cardId);
                            if (cardCounter === 3) {
                                self.onPlayerWin(data.currentWin.toString(), data.futureWin.toString());
                            }
                        }
                    })(i);
                }

                // WAIT AND CLOSE ALL CARDS
                setTimeout(function () {
                    self.gotoNextRiskStep();

                    self.pickShield.visible = false;

                    for (var i = 0; i < self.CARDS_NUMBER; ++i) {
                        (function (k) {
                            if (k === 0) {

                                cardId = data.processed.dealer.suit * 13 + data.processed.dealer.rank;
                                console.log('CLOSE CARD:', cardId);
                                self.closeCard(k, cardId, done);
                            }
                            else {
                                cardId = data.processed.cards[k-1].suit * 13 + data.processed.cards[k-1].rank;

                                self.closeCard(k, cardId);
                            }

                        })(i);
                    }

                }, 1500); // wait for show opened cards

            }.bind(this), 500); // wait for opening other cards

        }.bind(this)); // wait for opening selected card
    };

    FiveCardRisk.prototype.showPlayerLose = function (data, done) {
        var self = this;

        this.startShowResult();

        var cardId = data.processed.cards[data.processed.choice - 1].suit * 13 + data.processed.cards[data.processed.choice - 1].rank;

        this.openCard(data.processed.choice, cardId, function () {

            setTimeout(function () {

                // OPEN OTHER CARDS
                var cardCounter = 0;

                for (var i = 0; i < this.CARDS_NUMBER - 1; ++i) {
                    (function (k) {
                        if (k + 1 != data.processed.choice) {
                            cardId = data.processed.cards[k].suit * 13 + data.processed.cards[k].rank;

                            cardCounter++;

                            // к последней карте привязываем событие показа баннера и обнуление счетчиков
                            self.openCard(k + 1, cardId);
                            if (cardCounter === 3) {
                                self.onPlayerLose();
                            }
                        }
                    })(i);
                }

                // WAIT AND EXIT RISK
                setTimeout(done, 1500); // wait for showing result

            }.bind(this), 500);
        }.bind(this));

    };

    FiveCardRisk.prototype.showDrawEvent = function (data, done) {
        var self = this;
        this.startShowResult();

        var cardId = data.processed.cards[data.processed.choice - 1].suit * 13 + data.processed.cards[data.processed.choice - 1].rank;

        this.openCard(data.processed.choice, cardId, function () {

            setTimeout(function () {

                // OPEN OTHER CARDS
                var cardCounter = 0;

                for (var i = 0; i < this.CARDS_NUMBER - 1; ++i) {
                    (function (k) {
                        if (k + 1 != data.processed.choice) {
                            cardId = data.processed.cards[k].suit * 13 + data.processed.cards[k].rank;

                            cardCounter++;

                            // к последней карте привязываем событие показа баннера
                            if (cardCounter === 3) {
                                self.openCard(k + 1, cardId, self.onForwardEvent.bind(self));
                            }
                            else {
                                self.openCard(k + 1, cardId);
                            }
                        }
                    })(i);
                }

                // WAIT AND CLOSE ALL CARDS
                setTimeout(function () {
                    self.gotoNextRiskStep();

                    self.pickShield.visible = false;

                    for (var i = 0; i < self.CARDS_NUMBER; ++i) {
                        (function (k) {
                            if (k === 0) {
                                cardId = data.processed.dealer.suit * 13 + data.processed.dealer.rank;
                                console.log('CLOSE CARD:', cardId);
                                self.closeCard(k, cardId, done);
                            }
                            else {
                                cardId = data.processed.cards[k-1].suit * 13 + data.processed.cards[k-1].rank;
                                self.closeCard(k, cardId);
                            }

                        })(i);
                    }

                }, 1500); // wait for show opened cards

            }.bind(this), 500); // wait for opening other cards

        }.bind(this)); // on opening selected card
    };

    /**
     * Open the card
     * @param {Number} id index of flipping card
     * @param {Number} cardId index in card deck of flipping card
     *
     * * */
    FiveCardRisk.prototype.openCard = function(id, cardId, done) {

        done = done || function () {};

        var shirt = this.shirts[id];
        var face = this.deck[cardId];

        face.visible = false;
        face.scale.x = 0.005;
        face.position.set(this.X_START + id * this.X_OFFSET + ((id > 0) ? this.X_START_OFFSET : 0), this.Y_CARDS);

        var scaleInTween = new TWEEN.Tween(face.scale)
            .to({x: 1.0}, this.FLIP_TIME)
            .easing(TWEEN.Easing.Sinusoidal.Out)
            .onComplete(done.bind(this));

        var scaleOutTween = new TWEEN.Tween(shirt.scale)
            .to({x: 0.005}, this.FLIP_TIME)
            .easing(TWEEN.Easing.Sinusoidal.Out)
            .chain(scaleInTween)
            .onComplete(function() {
                shirt.visible = false;
                face.visible = true;
            })
            .start();
    };

    /**
     * Close the card
     * @param {Number} id index of flipping card
     * @param {Number} value index in card deck of flipping card
     *
     * * */
    FiveCardRisk.prototype.closeCard = function(id, cardId, done) {

        done = done || function () {};

        var shirt = this.shirts[id];
        var face = this.deck[cardId];

        shirt.visible = false;
        shirt.scale.x = 0.005;

        var scaleInTween = new TWEEN.Tween(shirt.scale)
            .to({x: 1.0}, this.FLIP_TIME)
            .easing(TWEEN.Easing.Sinusoidal.Out)
            .onComplete(done.bind(this));

        var scaleOutTween = new TWEEN.Tween(face.scale)
            .to({x: 0.005}, this.FLIP_TIME)
            .easing(TWEEN.Easing.Sinusoidal.Out)
            .chain(scaleInTween)
            .onComplete(function () {
                face.visible = false;
                shirt.visible = true;
            })
            .start();
    };

    FiveCardRisk.prototype.createCard = function (suite, nominal) {

        //*********************
        // var card = new PIXI.Sprite(PIXI.utils.TextureCache[""]);
        //
        // ** some code for creating card **
        //
        // return card;
        // **********************
        throw new Error('function "createCard" should be overridden in derived class');
    };


    global.FiveCardRisk = FiveCardRisk;
}(typeof module === 'object' && module.exports || this));


//////////////////
// WEBPACK FOOTER
// ./src/library/five_card_risk.js
// module id = 91
// module chunks = 0